import React, { useState } from 'react';
import Logo from '../assets/WebsiteLogoNoBG.webp';
import { FaAngleDoubleLeft } from 'react-icons/fa';
import { Link as RouterLink, useLocation } from 'react-router-dom';

const Header: React.FC = () => {
  const location = useLocation();
  
  // Determine which series we're on from URL
  const currentSeries = location.pathname.includes('/acl') ? 'acl' : 'safmc';

  const [isBackHovered, setIsBackHovered] = useState(false);

  const handleLogoClick = () => {
    window.location.href = 'https://rifqifarhansyah.id';
  };

  return (
    <div className='shadow-md w-screen fixed top-0 left-0 z-[10000]'>
      <div className='flex items-center justify-between bg-white py-4 md:px-10 px-7'>
        {/* logo section */}
        <div
          className='font-bold text-sm cursor-pointer flex items-center gap-1'
          onClick={handleLogoClick}
        >
          <img
            src={Logo}
            alt="Rifqi Website Logo"
            className='w-12 h-12'
            width="12"
            height="12"
            loading="lazy"
          />
        </div>

        {/* BACK TO BLOG (always visible, all screen sizes) */}
        <RouterLink
          to={`/${currentSeries}`}
          title={`Back to ${currentSeries.toUpperCase()} Blog`}
          className='inline-flex items-center font-condensed px-5 py-1 border border-opacity-25 text-sm font-thin hover:bg-hoverDarkGrey hover:border-opacity-50 rounded-full uppercase focus:outline-none relative'
          onMouseEnter={() => setIsBackHovered(true)}
          onMouseLeave={() => setIsBackHovered(false)}
        >
          <FaAngleDoubleLeft
            className={`w-3 h-3 text-rgba-28-5-179 ml-2 absolute left-0 transition-all duration-300 ${
              isBackHovered ? 'opacity-100 text-white' : 'opacity-0'
            }`}
          />
          <span
            className={`transition-all duration-300 ${
              isBackHovered ? 'pl-2 translate-x-1 text-white' : 'pl-1'
            }`}
          >
            BACK TO BLOG
          </span>
        </RouterLink>
      </div>
    </div>
  );
};

export default Header;
